import { useTranslation } from "react-i18next";
import { formatLongDatetime } from "@/helpers/dates";
import { euros, Section } from "./layout";

// Enough of the fingerprint to tell closures apart on paper; the whole of it
// stays a hover away, and with the API for anyone checking the chain.
const shortFingerprint = (fingerprint: string) => fingerprint.slice(0, 16);

/** The seal the API put on the day, once the day is over and closed. */
const ClosureDetails = ({ closure }: { closure: Closure }) => {
	const { t } = useTranslation();

	return (
		<Section title={t("dailyReport.closure")}>
			<div className="grid grid-cols-3 gap-4 text-sm print:text-xs">
				<div className="flex flex-col gap-1">
					<p className="text-small">{t("dailyReport.closureNumber")}</p>
					<p className="tabular-nums">{closure.number}</p>
				</div>
				<div className="flex flex-col gap-1">
					<p className="text-small">{t("dailyReport.perpetualTotal")}</p>
					<p className="tabular-nums">{euros(closure.perpetualTotalCents)}</p>
				</div>
				<div className="flex flex-col gap-1">
					<p className="text-small">{t("dailyReport.fingerprint")}</p>
					<p className="font-mono" title={closure.fingerprint}>
						{shortFingerprint(closure.fingerprint)}…
					</p>
				</div>
			</div>
			<p className="text-small">
				{t("dailyReport.closedAt", {
					date: formatLongDatetime(closure.createdAt),
				})}
			</p>
		</Section>
	);
};

export default ClosureDetails;
